import React from "react";

/**
 * Minimalist "Intelligent Assistant" glyph — clean vector, uniform strokes.
 * A softly-rounded chat bubble with a spark/sparkle inside representing AI.
 * Designed to feel premium (Apple/Stripe) and identifiable as an AI assistant.
 */
export const AssistantSparkIcon = ({ size = 26, className = "", stroke = "currentColor" }) => (
    <svg
        viewBox="0 0 32 32"
        width={size}
        height={size}
        className={className}
        aria-hidden="true"
    >
        {/* Rounded bubble */}
        <path
            d="M6 12a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7v3a7 7 0 0 1-7 7h-3.6l-4.9 3.6a.75.75 0 0 1-1.2-.6v-3.5A7 7 0 0 1 6 15v-3Z"
            fill="none"
            stroke={stroke}
            strokeWidth="1.7"
            strokeLinejoin="round"
        />
        {/* Central 4-point sparkle */}
        <path
            d="M16 10.5v7M12.5 14h7"
            stroke={stroke}
            strokeWidth="1.7"
            strokeLinecap="round"
        />
        {/* Diagonal accent sparkle (smaller) */}
        <path
            d="M20.4 10.4l1 1M11.6 16.6l1 1"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            opacity="0.85"
        />
    </svg>
);

export default AssistantSparkIcon;
